import { getCustomPdf, downloadPdf, openPrintPage } from 'b2b-common/services/api/document'

export default {
  data () {
    return {
      modal: false,
      priceDetailsModal: false,
      infoResults: [],
      selectedResults: [],
      searchIsRunning: false,
      currentPage: 1,
      resultsPerPage: Number.MAX_SAFE_INTEGER
    }
  },
  computed: {
    paginatedResults () {
      return this.model.results.slice((this.currentPage - 1) * this.resultsPerPage, this.currentPage * this.resultsPerPage)
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
      // document.getElementById('resultsHr').scrollIntoView()
    },
    onInfo (results) {
      this.infoResults = results
      this.modal = true
    },
    onInfoSelected () {
      this.infoResults = this.selectedResults
      this.modal = true
    },
    onHideSelected () {
      this.selectedResults = []
    },
    isSelected (result) {
      return this.selectedResults.indexOf(result) >= 0
    },
    onToggle (result) {
      const index = this.selectedResults.indexOf(result)
      if (index >= 0) this.selectedResults.splice(index, 1)
      else this.selectedResults.push(result)
    },
    onModalClose () {
      this.modal = false
    },
    priceDetails () {
      this.priceDetailsModal = true
    },
    closePriceDetailsModal () {
      this.priceDetailsModal = false
    },
    onPrint () {
      const html = document.getElementById('printArea').innerHTML
      openPrintPage({ html })
    },
    onDownload () {
      const html = document.getElementById('printArea').innerHTML
      getCustomPdf({ html })
        .then(pdfData => {
          downloadPdf({ pdfData, fileName: 'oferta.pdf', dataType: 'raw' })
        })
    },
    onSort (sortMethod) {
      this.model.sort({ sortMethod })
    },
    onPaginate (noResults) {
      this.resultsPerPage = noResults
    },
    onSearch (params) {
      this.searchIsRunning = true
      this.infoResults = []
      this.model.search(params)
        .finally(() => { this.searchIsRunning = false })
    }
  }
}
